webpackJsonp([10991734084388],{

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(23);
	
	var _Seo = __webpack_require__(65);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _siteMeta = __webpack_require__(27);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Col = __webpack_require__(14);
	
	var _Col2 = _interopRequireDefault(_Col);
	
	var _Row = __webpack_require__(15);
	
	var _Row2 = _interopRequireDefault(_Row);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import FunShapes from '../../common/FunShapes';
	
	
	var About = function (_PureComponent) {
	  _inherits(About, _PureComponent);
	
	  function About() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, About);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  About.prototype.componentDidMount = function componentDidMount() {
	    this.props.dispatch(_siteMeta.SiteMetaActions.updateSiteMetaColor('white'));
	  };
	
	  About.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'about' },
	      _react2.default.createElement(_Seo2.default, {
	        title: 'About',
	        url: this.props.pageResources ? this.props.pageResources.page.path : null }),
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'about__profile-area' },
	          _react2.default.createElement('img', {
	            src: 'https://res.cloudinary.com/camador/image/upload/v1525135385/webfolio/profile.jpg',
	            alt: '',
	            className: 'about__profile-image'
	          })
	        ),
	        _react2.default.createElement(
	          _Row2.default,
	          null,
	          _react2.default.createElement(
	            _Col2.default,
	            { className: 'col-xs-12 col-sm-9' },
	            _react2.default.createElement(
	              'div',
	              { className: 'about__content' },
	              _react2.default.createElement(
	                'p',
	                { className: 'h1' },
	                'Hello...'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'h2' },
	                'I\'m Chris, a Creative Front-End Developer in the D.C area that deeply cares for design and development.'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Row2.default,
	          null,
	          _react2.default.createElement(
	            _Col2.default,
	            { className: 'col-xs-12 col-sm-9' },
	            _react2.default.createElement(
	              'div',
	              { className: 'about__content' },
	              _react2.default.createElement(
	                'p',
	                { className: 'h3' },
	                'Both are my passion, I enjoy every facet that comes with the process of designing an idea to an actual product. The thrill of creating is what pushes me in my career and it\u2019s what excites me everyday. I love beautiful typography, modern minimal designs, strong layouts, and simple solutions to complicated problems.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'about__contact-area' },
	                _react2.default.createElement(
	                  'a',
	                  { href: 'mailto:chris@chrisamador.me?subject=Website Contact&body=Hi Chris,', className: 'btn btn-white' },
	                  'Let\'s Talk!'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Col2.default,
	            { className: 'col-xs-12 col-sm-3' },
	            _react2.default.createElement(
	              'div',
	              { className: 'about__content' },
	              _react2.default.createElement(
	                'div',
	                { className: 'about__meta' },
	                _react2.default.createElement(
	                  'h6',
	                  null,
	                  'Years of Exp'
	                ),
	                _react2.default.createElement(
	                  'small',
	                  null,
	                  '7, 2011 - 2018'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'about__meta' },
	                _react2.default.createElement(
	                  'h6',
	                  null,
	                  'Formal EDU.'
	                ),
	                _react2.default.createElement(
	                  'small',
	                  null,
	                  'BFA, George Mason U.'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'about__social' },
	                _react2.default.createElement(
	                  'ul',
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'a',
	                      {
	                        target: '_blank',
	                        rel: 'noopener noreferrer',
	                        href: 'http://codepen.io/chrisamador/' },
	                      _react2.default.createElement(_Icon2.default, { id: 'icon-codepen-logo' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'a',
	                      {
	                        target: '_blank',
	                        rel: 'noopener noreferrer',
	                        href: 'https://github.com/chrisamador' },
	                      _react2.default.createElement(_Icon2.default, { id: 'icon-github' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'a',
	                      {
	                        target: '_blank',
	                        rel: 'noopener noreferrer',
	                        href: 'https://www.linkedin.com/in/chris-amador-b3307288' },
	                      _react2.default.createElement(_Icon2.default, { id: 'icon-linkedin' })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return About;
	}(_react.PureComponent);
	
	exports.default = (0, _reactRedux.connect)(function () {
	  return {};
	})(About);
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-index-js-d121d811ff30d9f0f0e1.js